import { Outlet } from "react-router-dom"

import PageContainer from "components/PageContainer/PageContainer"

const SearchPageContainer = () => (
  <PageContainer>
    <Outlet />
  </PageContainer>
)

export default SearchPageContainer
